export enum SeeOption {
  TSPUseCases = 'TSP Use Cases',
  NonTSPUseCases = 'Standard Use Cases',
  Less = 'Less',
  More = 'More',
  All = 'All'
}
